// @flow
import env from '../../environment';

export type ConfigurationAdmin = {
  admin1: {
    label: string,
    enabled: boolean,
  },
  admin2: {
    label: string,
    enabled: boolean,
  },
  admin3: {
    label?: string,
    enabled: boolean,
  },
};

export type Admin1Type = {
  admin1Id: number,
  admin1Name: string,
  already_used?: boolean,
  type: 'admin1',
};
export type Admin2Type = {
  admin2Id: number,
  admin2Name: string,
  already_used?: boolean,
  type: 'admin2',
};
export type Admin3Type = {
  admin3Id: number,
  admin3Name: string,
  already_used?: boolean,
  type: 'admin3',
};

export const endpoints = Object.freeze({
  FETCH_LOCATION: `${env.baseApiUrl}/im/location`,
  FETCH_AVAILABLE_LOCATION: `${env.baseApiUrl}/im/location/available`,
  FETCH_VALIDATE_LOCATION: `${env.baseApiUrl}/im/admin/location/status`,
  FETCH_LOCATION_DETAIL: `${env.baseApiUrl}/im/admin/location/detail`,
});
